import ServerConnector from "../utils/ServerConnector";

export const verifyCheckoutSession = async (checkoutSessionIdToValidate) => {
  try {
    const response = await ServerConnector.post(
      "/utilities/validate/checkout-session",
      checkoutSessionIdToValidate
    );
    return response;
  } catch (err) {
    console.log(err);
    return err.response;
  }
};
